import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import axios from 'axios';
import useApi from '../../api/useApi';

function ZplFiles({ orgId, goBack }) {
  const [zplFilesRes, getZplFile] = useApi();
  const [uploadRes, uploadZplFile] = useApi();
  const [projectRes, getProject] = useApi();
  const [singleZplFilesRes, getSingleZplFile] = useApi();
  const [postZplDataRes, postZplData] = useApi();
  const [deleteZplRes, deleteZpl] = useApi();

  const formModel = {
    name: '',
    projectId: '',
    dpmm: '',
    width: '',
    height: '',
    index: '',
    url: '',
  };

  const [formData, setFormData] = useState(formModel);
  const [selectedFile, selectFile] = useState(false);
  const [uploadData, uploadZplData] = useState(false);
  const [zplMap, setZplMap] = useState();
  const [typeMatch, setTypeMatch] = useState(true);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState('');
  const [zipFiles, setZipFiles] = useState([]);
  const [selectedZip, selectZip] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);
  const [selectedPreviewFile, selectPreviewFile] = useState();

  const fileRef = useRef();

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
    getZplFile(`/organization/${orgId}/zplFiles`, 'GET');
  }, []);

  useEffect(() => {
    if (!projectRes.isLoading && !projectRes.isError && projectRes.data) {
      setProjects(projectRes.data.projects);
    }
  }, [projectRes]);

  useEffect(() => {
    if (!zplFilesRes.isLoading && !zplFilesRes.isError && zplFilesRes.data) {
      setZipFiles(zplFilesRes.data.zplFiles);
    }
  }, [zplFilesRes.isLoading, zplFilesRes.isError, zplFilesRes.data]);

  const handleChange = (e) => {
    const [file] = e.target.files;
    if (file) {
      if (file && file.name.split('.')[1].toLowerCase() === 'zpl') {
        setZplMap(file);
        setTypeMatch(false);
      }
    }
  };

  const handleSubmitFile = (e) => {
    e.preventDefault();
    const x = new FormData();
    x.append('file', zplMap, zplMap.name);

    uploadZplFile(`/zplFile/${selectedFile.id}/upload`, 'POST', x);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = {
      ...formData,
      projectId: getProjectId(formData.projectId),
      index: formData.index == '' ? 0 : formData.index,
      dpmm: (+formData.dpmm / 25.4).toFixed(0),
    };
    // console.log(body);
    if (selectedZip) postZplData(`/zplFile/${selectedZip.id}`, 'PATCH', body);
    else postZplData(`/zplFile`, 'POST', body);
  };

  useEffect(() => {
    if (!postZplDataRes.isLoading && !postZplDataRes.isError && postZplDataRes.data) {
      uploadZplData(false);
      selectZip(null);
      getZplFile(`/organization/${orgId}/zplFiles`, 'GET');
    }
  }, [postZplDataRes.isLoading, postZplDataRes.isError, postZplDataRes.data]);

  useEffect(() => {
    if (!uploadRes.isLoading && !uploadRes.isError && uploadRes.data) {
      if (!selectedFile) {
        setZplMap(null);
        setProjectId('');
      } else {
        selectZip(null);
      }
      selectFile(null);
      setFormData(formModel);
      getZplFile(`/organization/${orgId}/zplFiles`, 'GET');
    }
  }, [uploadRes.isLoading, uploadRes.isError, uploadRes.data]);

  const getProjectId = (name) => {
    const project = projects.filter((item) => item.projectName === name);
    if (project.length > 0) {
      return project[0].id;
    }
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  useEffect(() => {
    if (selectedZip) {
      uploadZplData(true);
      getSingleZplFile(`/zplFile/${selectedZip.id}`, 'GET');
    }
  }, [selectedZip]);

  useEffect(() => {
    if (!singleZplFilesRes.isLoading && !singleZplFilesRes.isError && singleZplFilesRes.data) {
      if (selectedZip)
        setFormData({
          ...singleZplFilesRes.data.zplFile,
          projectId: singleZplFilesRes.data.zplFile.Project.projectName,
          dpmm: (singleZplFilesRes.data.zplFile.dpmm * 25.4).toFixed(0),
        });
      else fetchImage(singleZplFilesRes.data.file);
    }
  }, [singleZplFilesRes.isLoading, singleZplFilesRes.isError, singleZplFilesRes.data]);

  const fetchImage = (zpl) => {
    setShowPreview(true);
    const x = new FormData();
    const blob = new Blob([zpl], { type: 'text/plain' });
    const file = new File([blob], 'foo.zpl');
    x.append('file', file);
    axios({
      method: 'POST',
      url: `https://api.labelary.com/v1/printers/${selectedPreviewFile.dpmm || 8}dpmm/labels/${
        selectedPreviewFile.width || 4
      }x${selectedPreviewFile.height || 6}/${selectedPreviewFile.index}`,
      data: x,
      responseType: 'blob',
    })
      .then((data) => {
        if (data) {
          const reader = new FileReader();
          reader.readAsDataURL(data.data);
          reader.onloadend = () => {
            const base64data = reader.result;
            setPreviewImage(base64data);
          };
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (selectedPreviewFile) {
      getSingleZplFile(`/organization/${orgId}/zplFile?name=${selectedPreviewFile.name}`, 'GET');
    }
  }, [selectedPreviewFile]);

  const handleDelete = (x) => {
    deleteZpl(`/zplFile/${x.id}`, 'DELETE');
  };

  useEffect(() => {
    if (!deleteZplRes.isLoading && !deleteZplRes.isError && deleteZplRes.data) {
      getZplFile(`/organization/${orgId}/zplFiles`, 'GET');
    }
  }, [deleteZplRes.isLoading, deleteZplRes.isError, deleteZplRes.data]);

  return (
    <>
      {/* upload file start */}
      {selectedFile && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-1/3 pt-1 relative rounded-2xl mobile_toggle">
            <div className="flex justify-between border-b px-5 py-4">
              <p className="font-bold text-sm text-textBlue1">Upload ZPL File</p>

              <img
                src="assets/img/Close.svg"
                className="h-3 mt-1 cursor-pointer z-50"
                alt=""
                onClick={() => {
                  selectFile(null);
                  selectZip(null);
                }}
              />
            </div>

            <form className="mt-2 mb-2 flex flex-wrap " onSubmit={handleSubmitFile} autoComplete="off">
              <div className="w-full relative flex flex-col items-center px-5">
                <div
                  className="inputLabelText px-4 mx-5 w-full mt-5 py-2.5 focus:outline-none relative text-sm cursor-pointer"
                  onClick={() => fileRef.current.click()}
                >
                  <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
                  <input ref={fileRef} onChange={handleChange} multiple={false} type="file" hidden />
                  Upload ZPL File
                </div>

                {zplMap && (
                  <span className="mt-5 relative mr-2 ml-4 text-xs p-2 gap-x-4 flex items-center border rounded-full px-4 py-2">
                    {zplMap ? <span>{zplMap?.name} </span> : ''}
                    {zplMap && zplMap?.name ? (
                      <img
                        src="assets/img/Close.svg"
                        className="h-2 cursor-pointer"
                        alt=""
                        onClick={() => {
                          setZplMap(null);
                          fileRef.current.value = null;
                        }}
                      />
                    ) : null}
                  </span>
                )}
              </div>

              <div className="w-full flex mt-10 mb-2 relative ml-auto">
                {uploadRes.isLoading ? (
                  <img src="assets/img/loader.svg" className="w-16 ml-auto bottom-0" alt="" />
                ) : (
                  <div className="flex justify-between w-full px-5 text-xs">
                    {!selectedZip && (
                      <span className="text-red-400 ml-4" style={{ fontSize: 10 }}>
                        *Filetype could be .zpl
                      </span>
                    )}
                    <button
                      type="submit"
                      className="rounded-3xl ml-auto w-32 focus:outline-none py-2 text-xs text-white bg-primary cursor-pointer "
                      style={{ border: '1px solid #16406D' }}
                      disabled={selectedZip ? false : typeMatch}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {/* upload file end */}

      {/* upload form start */}
      {uploadData && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-1/3 pt-1 relative rounded-2xl mobile_toggle">
            <div className="flex justify-between border-b px-5 py-4">
              <p className="font-bold text-sm text-textBlue1">{`${
                selectedZip ? 'Edit' : 'Create'
              } ZPL File Details`}</p>

              <img
                src="assets/img/Close.svg"
                className="h-3 mt-1 cursor-pointer z-50"
                alt=""
                onClick={() => {
                  uploadZplData(false);
                  selectZip(null);
                  setFormData(formModel);
                }}
              />
            </div>

            <form className="mt-2 mb-2 flex flex-wrap " onSubmit={handleSubmit} autoComplete="off">
              <div className="w-full relative flex flex-col items-center px-5">
                <div className="mt-5 w-full relative">
                  <div className="px-4 py-2 focus:outline-none inputLabelText">
                    <input
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="text"
                      placeholder="Name"
                      name="name"
                      autoComplete="off"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="px-4 py-2 mt-4 focus:outline-none inputLabelText">
                    <select
                      // size="10"
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="text"
                      placeholder="Project"
                      list="projectId"
                      name="projectId"
                      autoComplete="off"
                      value={formData.projectId}
                      onChange={handleInputChange}
                    >
                      <option className="fy-4" value="default">
                        Select Project
                      </option>
                      {projects.map((item) => (
                        <option key={item?.id}>{item?.projectName}</option>
                      ))}
                    </select>
                  </div>

                  <div className="px-4 py-2 mt-4 focus:outline-none inputLabelText">
                    <input
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="number"
                      placeholder="Print Density in dpi"
                      name="dpmm"
                      autoComplete="off"
                      value={formData.dpmm}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="px-4 py-2 mt-4 focus:outline-none inputLabelText">
                    <input
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="number"
                      placeholder="Width in inches"
                      name="width"
                      autoComplete="off"
                      value={formData.width}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="px-4 py-2 mt-4 focus:outline-none inputLabelText">
                    <input
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="number"
                      placeholder="Height in inches"
                      name="height"
                      autoComplete="off"
                      value={formData.height}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="px-4 py-2 mt-4 focus:outline-none inputLabelText">
                    <input
                      className="border-none w-full focus:outline-none text-sm  text-parameter border dropDown "
                      type="number"
                      placeholder="Index (must always be 0)"
                      name="index"
                      autoComplete="off"
                      value={formData.index}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="w-full flex mt-6 mb-2 relative ml-auto">
                {postZplDataRes.isLoading ? (
                  <img src="assets/img/loader.svg" className="w-14 ml-auto mr-6" alt="" />
                ) : (
                  <div className="flex justify-between w-full px-5 text-xs">
                    <button
                      type="submit"
                      className="rounded-3xl ml-auto w-32 focus:outline-none py-2 text-xs text-white bg-primary cursor-pointer "
                      style={{ border: '1px solid #16406D' }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {/* upload form end */}

      {/* image preview start */}
      {showPreview && (
        <div
          className="flex justify-center items-center h-full w-full fixed top-0 left-0 devices_back"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-1/3 pt-1 relative rounded-2xl mobile_toggle">
            <div className="flex justify-between border-b px-5 py-4">
              <p className="font-bold text-sm text-textBlue1">{`Preview of ${selectedPreviewFile.name} ZPL File`}</p>

              <img
                src="assets/img/Close.svg"
                className="h-3 mt-1 cursor-pointer z-50"
                alt=""
                onClick={() => {
                  setShowPreview(false);
                  setPreviewImage(null);
                  selectPreviewFile(null);
                }}
              />
            </div>

            <div className="border m-6">
              <img src={`${previewImage}`} className="w-full" style={{ height: '77vh' }} alt="" />
            </div>
          </div>
        </div>
      )}
      {/* image preview end */}

      {/* main page start */}
      <div className="mt-10 h-full bg-white mx-auto px-3 rules_ui overflow-auto">
        <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-titleColor font-bold text-base mobile_icon2">Zpl Files</span>

            <div className="block lg:flex mt-1 lg:mt-0 ">
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                onClick={() => {
                  goBack();
                }}
              >
                Back
              </button>

              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                onClick={() => {
                  // UploadZplFile(true);
                  uploadZplData(true);
                }}
              >
                Create New
                <img src="assets/img/Create.svg" className="h-3 ml-2 transform -rotate-270" alt="" />
              </button>

              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                onClick={() => {
                  // downloadExcel('tblData');
                }}
              >
                Report
                <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
              </button>
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  // value={formData.q}
                  // name="q"
                  // onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    //   if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={() => {}} className="h-4 ml-2 button_search3 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center resp_rule">
                <div className=" py-2.5 text-xs font-bold w-2/12">NAME</div>
                <div className=" py-2.5 text-xs font-bold w-2/12">PROJECT</div>
                <div className=" py-2.5 text-xs font-bold w-2/12">PRINT DENSITY</div>
                <div className=" py-2.5 text-xs font-bold w-1/12">HEIGHT</div>
                <div className=" py-2.5 text-xs font-bold w-1/12">WIDTH</div>
                <div className=" py-2.5 text-xs font-bold w-1/12">STATUS</div>
                <div className=" py-2.5 text-xs font-bold w-2/12">LAST MODIFIED</div>
                <div className=" py-2.5 text-xs font-bold w-1/12 text-center">ACTIONS</div>
              </div>
            </div>
            {!zplFilesRes.isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '70vh' }}>
                <div className="w-full">
                  {zipFiles.map((item) => (
                    <div
                      className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                      relative hover:border-indigo-200 focus-within:border-indigo-200 focus:bg-rowSelect hover:bg-rowSelect"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <div
                        className={` font-semibold text-left text-role py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12`}
                      >
                        {item?.name}
                      </div>
                      <div
                        className={` font-semibold text-left text-role py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12`}
                      >
                        {item?.Project?.projectName}
                      </div>
                      <div className="font-semibold text-left text-role py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {`${(item?.dpmm * 25.4).toFixed(0)} dpi`}
                      </div>
                      <div className="font-semibold text-left text-role py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/12">
                        {`${item?.height} inches`}
                      </div>
                      <div className="font-semibold text-left text-role py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/12">
                        {`${item?.width} inches`}
                      </div>
                      <div
                        className={` text-${
                          item?.isActive ? 'green-600' : 'red-600'
                        }  font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/12`}
                      >
                        {item?.isActive ? 'Active' : 'Inactive'}
                      </div>
                      <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                        {getTimeoffset(item?.updatedAt)}
                      </div>
                      <div className="flex justify-center text-left py-2 w-1/12 gap-x-4">
                        <img
                          src="assets/img/Edit2.svg"
                          className="h-3 cursor-pointer"
                          alt=""
                          onClick={() => {
                            selectZip(item);
                          }}
                        />

                        <img
                          src="assets/img/preview.svg"
                          className="h-4 cursor-pointer"
                          onClick={() => selectPreviewFile(item)}
                        />

                        <img
                          src="assets/img/upload2.svg"
                          className="h-3 cursor-pointer"
                          alt=""
                          onClick={() => selectFile(item)}
                        />

                        <img
                          src="assets/img/Delete_Blue.svg"
                          className="h-4 cursor-pointer"
                          alt=""
                          onClick={() => handleDelete(item)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
      {/* main page end */}
    </>
  );
}

export default ZplFiles;
